(function() {
  var $41c52a4cf9d0d60e$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("recommended-products-tabs")) return;
    customElements.define("recommended-products-tabs", class RecommendedProductsTabs extends HTMLElement {
      constructor() {
        super();
        this._activeTab = null;
        this._onTabClick = this._onTabClick.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onContentState = this._onContentState.bind(this);
      }
      connectedCallback() {
        this.sectionRoot = this.closest("[data-rp-section-root]");
        this.tabButtons = Array.from(this.querySelectorAll("[data-rp-tab-button]"));
        this.panels = Array.from(this.querySelectorAll("[data-rp-panel]"));
        this.unifiedControls = this.querySelector("[data-rp-controls-unified]");
        this.recentlySlider = this.querySelector("[data-rp-recently-slider]");
        this.relatedProducts = this.querySelector("[data-rp-related-products]");
        this.sliderComponents = Array.from(this.querySelectorAll("slider-component[data-rp-slider-id]"));
        if (!this.tabButtons.length) return;
        this.addEventListener("click", this._onTabClick);
        this.addEventListener("keydown", this._onKeyDown);
        this.addEventListener("recently-viewed:state", this._onContentState);
        this.addEventListener("related-products:state", this._onContentState);
        this._syncState();
      }
      disconnectedCallback() {
        this.removeEventListener("click", this._onTabClick);
        this.removeEventListener("keydown", this._onKeyDown);
        this.removeEventListener("recently-viewed:state", this._onContentState);
        this.removeEventListener("related-products:state", this._onContentState);
      }
      _onContentState() {
        this._syncState();
      }
      _onTabClick(event) {
        const tab = event.target.closest("[data-rp-tab-button]");
        if (!tab) return;
        const key = tab.dataset.rpTabButton;
        if (!key || tab.getAttribute("aria-hidden") === "true") return;
        this._activeTab = key;
        this._syncState();
      }
      _onKeyDown(event) {
        const tab = event.target.closest("[data-rp-tab-button]");
        if (!tab) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          tab.click();
          return;
        }
        const interactiveTabs = this.tabButtons.filter(button => button.getAttribute("aria-hidden") !== "true");
        if (!interactiveTabs.length) return;
        const currentIndex = interactiveTabs.indexOf(tab);
        if (currentIndex === -1) return;
        let targetIndex = -1;
        if (event.key === "ArrowRight") targetIndex = (currentIndex + 1) % interactiveTabs.length; else if (event.key === "ArrowLeft") targetIndex = (currentIndex - 1 + interactiveTabs.length) % interactiveTabs.length; else if (event.key === "Home") targetIndex = 0; else if (event.key === "End") targetIndex = interactiveTabs.length - 1; else return;
        event.preventDefault();
        const target = interactiveTabs[targetIndex];
        target.focus();
        target.click();
      }
      _syncState() {
        this.sliderComponents = Array.from(this.querySelectorAll("slider-component[data-rp-slider-id]"));
        this.recentlySlider = this.querySelector("[data-rp-recently-slider]");
        this.relatedProducts = this.querySelector("[data-rp-related-products]");
        const states = {
          recently: this._hasRecentlyContent(),
          complementary: this._hasComplementaryContent()
        };
        const availableTabs = this.tabButtons.map(button => button.dataset.rpTabButton).filter(tab => states[tab]);
        if (!availableTabs.includes(this._activeTab)) {
          if (availableTabs.includes("complementary")) this._activeTab = "complementary"; else this._activeTab = availableTabs[0] || null;
        }
        this.tabButtons.forEach(button => {
          const key = button.dataset.rpTabButton;
          const isAvailable = !!states[key];
          const isActive = key === this._activeTab && isAvailable;
          button.setAttribute("aria-hidden", isAvailable ? "false" : "true");
          button.setAttribute("aria-selected", isActive ? "true" : "false");
          button.tabIndex = isActive ? 0 : -1;
        });
        this.panels.forEach(panel => {
          const key = panel.dataset.rpPanel;
          const shouldShow = key === this._activeTab && !!states[key];
          panel.setAttribute("aria-hidden", shouldShow ? "false" : "true");
        });
        const activeSlider = this._getActiveSlider();
        this.sliderComponents.forEach(slider => {
          slider.dataset.rpActiveSlider = slider === activeSlider ? "true" : "false";
        });
        if (this.unifiedControls) {
          const hasMultiTargetConfig = this.unifiedControls.hasAttribute("data-slider-targets");
          if (activeSlider && this._activeTab) {
            if (!hasMultiTargetConfig) this.unifiedControls.dataset.sliderTarget = activeSlider.dataset.sliderId || "";
            this.unifiedControls.setAttribute("aria-hidden", "false");
            this.unifiedControls.dispatchEvent(new CustomEvent("slider-controls:refresh"));
          } else {
            if (!hasMultiTargetConfig) delete this.unifiedControls.dataset.sliderTarget;
            this.unifiedControls.setAttribute("aria-hidden", "true");
          }
        }
        if (this.sectionRoot) this.sectionRoot.setAttribute("aria-hidden", availableTabs.length ? "false" : "true");
        if (this.sectionRoot) this.sectionRoot.setAttribute("aria-hidden", availableTabs.length ? "false" : "true");
      }
      _getActiveSlider() {
        if (!this._activeTab) return null;
        return this.querySelector(`slider-component[data-rp-slider-id="${this._activeTab}"]`) || null;
      }
      _hasRecentlyContent() {
        return !!this.recentlySlider?.querySelector("[data-slide]");
      }
      _hasComplementaryContent() {
        if (!this.relatedProducts) return false;
        const slider = this.relatedProducts.querySelector("[data-slider]");
        if (slider?.children.length) return true;
        return !this.relatedProducts.classList.contains("hidden") && this.relatedProducts.innerHTML.trim() !== "";
      }
    });
  })();
})();